/**
 * A CHAVE DE UMA PEÇA NO MAPA DO SISTEMA — a mesma que `/system?no=` seleciona.
 *
 * Quem cunha a chave é o servidor (`nodeKey` em
 * `contexts/blueprint/domain/structure-graph.ts`); isto é a cópia de leitura,
 * para que uma página que mostra uma peça abra a mesma peça na estrutura sem
 * importar `features/system`.
 */
export const pieceKey = {
	entity: (code: string) => `entity:${code}`,
	field: (entity: string, code: string) => `field:${entity}.${code}`,
	view: (entity: string, code: string) => `view:${entity}.${code}`,
	/** O funil: `/funnels/:code` é o código do pipeline. */
	pipeline: (code: string) => `pipeline:${code}`,
	/** A função. */
	artifact: (code: string) => `artifact:${code}`,
	/**
	 * Pelo NOME da regra, não pelo id — é o que o servidor usa.
	 * shortcut: a 2ª regra com o mesmo nome vira `nome#2` no mapa e este link cai
	 * na 1ª; se nomes repetidos virarem comuns, o mapa precisa expor o id.
	 */
	automation: (name: string) => `automation:${name}`,
	report: (code: string) => `report:${code}`,
	agent: (code: string) => `agent:${code}`,
};

/** O destino do link "Ver na estrutura". */
export function systemPieceLink(key: string) {
	return { path: "/system", query: { no: key } };
}
